import { authSelectors, LoginScreen } from '@web/app/features/auth'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { z } from 'zod'

export const Route = createFileRoute('/_auth/sign-in')({
  validateSearch: z.object({
    redirect: z.string().optional(),
  }),
  component: RouteComponent,
})

function RouteComponent() {
  useRedirectIfAuthenticated()

  return <LoginScreen />
}

function useRedirectIfAuthenticated() {
  const router = useRouter()
  const isAuthenticated = useSelector(authSelectors.isAuthenticated)

  const search = Route.useSearch()

  useEffect(() => {
    if (isAuthenticated) {
      router.history.replace(search.redirect || '/')
    }
  }, [isAuthenticated])
}
